module.exports = __webpack_public_path__ + "assets/d6ed7061bbb9ff303926dc04b5b204cb.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/SecondTrigger.mp3
 ** module id = 377
 ** module chunks = 0
 **/